/* Linea — original theme script (no dependencies) */
(function () {
  'use strict';
  var L = window.Linea || {};

  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  /* ---------- Money ---------- */
  L.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || L.moneyFormat || '{{amount}}';
    function fmt(n, dec, thou, decSep) {
      dec = isNaN(dec) ? 2 : dec;
      var num = (n / 100).toFixed(dec).split('.');
      var whole = num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return whole + (num[1] ? decSep + num[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(cents, 2, "'", '.'); break;
      default: out = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  };

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = qs('button, a, input', d.querySelector('.drawer__panel'));
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  L.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer')); return; }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('.drawer.is-open').forEach(closeDrawer);
    qsa('.nav details[open]').forEach(function (d) { d.removeAttribute('open'); });
    var sm = qs('[data-search-modal]');
    if (sm && !sm.hidden) sm.hidden = true;
    var pop = qs('[data-popup]');
    if (pop && !pop.hidden) pop.hidden = true;
  });

  /* Close desktop dropdowns when clicking elsewhere / opening another */
  document.addEventListener('click', function (e) {
    qsa('.nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Announcement rotation ---------- */
  qsa('[data-announce]').forEach(function (bar) {
    var items = qsa('.announce__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setInterval(function () {
      items[i].classList.remove('is-active');
      items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      items[i].removeAttribute('aria-hidden');
    }, reduce ? 8000 : 5000);
  });

  /* ---------- Slideshow ---------- */
  function initSlides(root) {
    var slides = qsa('.slide', root);
    var dots = qsa('.slides__dots button', root);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var speed = parseInt(root.getAttribute('data-speed'), 10) * 1000 || 5000;
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].setAttribute('aria-current', 'false');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].setAttribute('aria-current', 'true');
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); restart(); }); });
    function restart() {
      if (timer) clearInterval(timer);
      if (root.getAttribute('data-autoplay') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () { go(i + 1); }, speed);
      }
    }
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      x0 = null;
    });
    restart();
  }
  qsa('[data-slides]').forEach(initSlides);
  document.addEventListener('shopify:section:load', function (e) {
    qsa('[data-slides]', e.target).forEach(initSlides);
  });

  /* ---------- Search ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    var m = qs('[data-search-modal]');
    if (!m) return;
    e.preventDefault();
    m.hidden = !m.hidden;
    t.setAttribute('aria-expanded', String(!m.hidden));
    if (!m.hidden) qs('input[type=search]', m).focus();
  });
  var pInput = qs('[data-predictive-input]');
  if (pInput && L.predictive) {
    var out = qs('[data-predictive-results]');
    var deb;
    pInput.addEventListener('input', function () {
      clearTimeout(deb);
      var q = pInput.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      deb = setTimeout(function () {
        fetch(L.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data.resources && data.resources.results.products) || [];
            out.innerHTML = prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=100" alt="" loading="lazy">' : '';
              return '<a href="' + p.url + '">' + img + '<span>' + p.title + '</span></a>';
            }).join('');
          }).catch(function () {});
      }, 250);
    });
  }

  /* ---------- Cart ---------- */
  function cartSections() { return qsa('[data-cart-section]').map(function (el) { return el.getAttribute('data-cart-section'); }); }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-section="' + id + '"]');
      qsa('[data-cart-section="' + id + '"]').forEach(function (old) {
        if (fresh) old.innerHTML = fresh.innerHTML;
      });
    });
  }
  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { if (!el.classList.contains('cart-dot')) el.textContent = count; el.setAttribute('data-count', count); });
  }
  function refreshCount() {
    fetch(L.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
  }

  function changeLine(line, qty) {
    return fetch(L.routes.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: cartSections() })
    }).then(function (r) { return r.json(); }).then(function (data) {
      renderSections(data.sections);
      if (typeof data.item_count === 'number') updateCount(data.item_count); else refreshCount();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (b) {
      var wrap = b.closest('.qty');
      var input = qs('input', wrap);
      var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
      if (input.hasAttribute('data-line')) {
        e.preventDefault();
        changeLine(parseInt(input.getAttribute('data-line'), 10), v);
      } else {
        input.value = Math.max(1, v);
      }
      return;
    }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line]');
    if (input) changeLine(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || L.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = qs('[type=submit]', form);
    var err = qs('[data-form-error]', form);
    if (err) err.hidden = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    fd.append('sections', cartSections().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(L.routes.add + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (err) { err.textContent = data.description || data.message; err.hidden = false; }
          return;
        }
        renderSections(data.sections);
        refreshCount();
        openDrawer('CartDrawer');
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  // Expostos para o bloco de bundle (snippets/bundle-offer.liquid)
  L.renderSections = renderSections;
  L.refreshCount = refreshCount;
  L.openDrawer = openDrawer;

  /* ---------- Product ---------- */
  function initProduct(root) {
    var dataEl = qs('[data-product-json]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = qs('form[data-product-form]', root);
    var idInput = form ? qs('input[name=id]', form) : null;
    var btn = form ? qs('[data-add-btn]', form) : null;
    var priceEl = qs('[data-price]', root);
    var skuEl = qs('[data-sku]', root);
    var invEl = qs('[data-inventory]', root);
    var sectionUrl = root.getAttribute('data-url');

    function selected() {
      var opts = [];
      qsa('[data-option-index]', root).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var sel = group.tagName === 'SELECT' ? group.value : (qs('input:checked', group) || {}).value;
        opts[idx] = sel;
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      qsa('[data-option-index]', root).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        qsa('input', group).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function showMedia(id) {
      if (!id) return;
      var target = qs('[data-media="' + id + '"]', root);
      if (!target) return;
      qsa('[data-media]', root).forEach(function (m) { m.classList.toggle('is-active', m === target); });
      qsa('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-thumb') === String(id))); });
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = L.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? L.strings.addToCart : L.strings.soldOut;
      }
      if (priceEl) {
        var html = '';
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (sale) html += '<s class="price__was">' + L.formatMoney(v.compare_at_price) + '</s>';
        html += '<span class="price__now">' + L.formatMoney(v.price) + '</span>';
        if (sale && priceEl.hasAttribute('data-show-save')) html += '<span class="price__save">' + L.strings.save.toUpperCase() + ' ' + (priceEl.hasAttribute('data-save-percent') ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : L.formatMoney(v.compare_at_price - v.price)) + '</span>';
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = html;
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (invEl) {
        var q = invEl.getAttribute('data-q-' + v.id);
        invEl.textContent = q || '';
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (sectionUrl && window.history.replaceState) {
        window.history.replaceState({}, '', sectionUrl + '?variant=' + v.id);
      }
    }
    root.addEventListener('change', function (e) {
      var g = e.target.closest('[data-option-index]');
      if (!g) return;
      var cur = g.closest('fieldset') && qs('[data-option-current]', g.closest('fieldset'));
      if (cur && e.target.value) cur.textContent = e.target.value;
      update();
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showMedia(t.getAttribute('data-thumb'));
    });
    markAvailability(selected());
  }
  qsa('[data-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) { qsa('[data-product]', e.target).forEach(initProduct); });


  /* ---------- Size guide + shipping date ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-size-guide-open]');
    if (o) { var m = qs('[data-size-guide]'); if (m) m.hidden = false; return; }
    var c = e.target.closest('[data-size-guide-close]');
    var mm = qs('[data-size-guide]');
    if (mm && (c || e.target === mm)) mm.hidden = true;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var m = qs('[data-size-guide]'); if (m) m.hidden = true; }
  });
  qsa('[data-ship-date]').forEach(function (el) {
    var d = new Date(Date.now() + 864e5);
    var lang = document.documentElement.lang || 'da';
    try {
      el.textContent = d.toLocaleDateString(lang, { weekday: 'long' }) + ', ' + d.getDate() + '.';
    } catch (err) { el.textContent = d.getDate() + '.'; }
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]');
    if (!s) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-filter-form]');
    if (f) f.submit();
  });

  /* ---------- Recently viewed ---------- */
  var rv = qs('[data-recent]');
  var key = 'linea_recent';
  var current = document.body.getAttribute('data-product-handle');
  var list = [];
  try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (err) { list = []; }
  if (current) {
    list = list.filter(function (h) { return h !== current; });
    list.unshift(current);
    list = list.slice(0, 12);
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (err) {}
  }
  if (rv) {
    var limit = parseInt(rv.getAttribute('data-limit'), 10) || 5;
    var handles = list.filter(function (h) { return h !== current; }).slice(0, limit);
    if (handles.length) {
      Promise.all(handles.map(function (h) {
        return fetch(L.routes.root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var html = products.filter(Boolean).map(function (p) {
          var onSale = p.compare_at_price > p.price;
          var pct = onSale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
          var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy">' : '';
          return '<div class="card"><a class="card__link" href="' + p.url + '"><div class="card__media card__media--' + (L.gridRatio || 'natural') + '">' +
            (onSale ? '<span class="card__pct">' + pct + '% SLEVA</span>' : '') + img +
            '</div><div class="card__meta"><h3 class="card__title">' + p.title + '</h3><span class="price' + (onSale ? ' price--sale' : '') + '">' +
            (onSale ? '<s>' + L.formatMoney(p.compare_at_price) + '</s> ' : '') + '<span class="price__now">' + L.formatMoney(p.price) + '</span></span></div></a></div>';
        }).join('');
        if (html) { qs('[data-recent-grid]', rv).innerHTML = html; rv.hidden = false; }
      });
    }
  }

  /* ---------- Newsletter popup ---------- */
  var pop = qs('[data-popup]');
  if (pop) {
    var days = parseInt(pop.getAttribute('data-days'), 10) || 7;
    var secs = parseInt(pop.getAttribute('data-delay'), 10) || 5;
    var seen = null;
    try { seen = localStorage.getItem('linea_popup'); } catch (err) {}
    var expired = !seen || (Date.now() - parseInt(seen, 10)) > days * 864e5;
    if (expired || pop.hasAttribute('data-force')) {
      setTimeout(function () { pop.hidden = false; }, secs * 1000);
    }
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) {
        pop.hidden = true;
        try { localStorage.setItem('linea_popup', String(Date.now())); } catch (err) {}
      }
    });
  }
})();

/* Contagem decrescente até à meia-noite (fuso configurável) */
(function () {
  var els = document.querySelectorAll('[data-countdown]');
  if (!els.length) return;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function secondsToMidnight(tz) {
    var h, m, s;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz || 'Europe/Madrid', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      parts.forEach(function (p) { if (p.type === 'hour') h = parseInt(p.value, 10) % 24; if (p.type === 'minute') m = parseInt(p.value, 10); if (p.type === 'second') s = parseInt(p.value, 10); });
    } catch (e) { var d = new Date(); h = d.getHours(); m = d.getMinutes(); s = d.getSeconds(); }
    return 86400 - (h * 3600 + m * 60 + s);
  }
  function tick() {
    els.forEach(function (el) {
      var left = secondsToMidnight(el.getAttribute('data-tz'));
      var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      var eh = el.querySelector('[data-cd-h]'), em = el.querySelector('[data-cd-m]'), es = el.querySelector('[data-cd-s]');
      if (eh) eh.textContent = pad(h);
      if (em) em.textContent = pad(m);
      if (es) es.textContent = pad(s);
    });
  }
  tick();
  setInterval(tick, 1000);
})();
